<template>
  <modal
    :is-hidden="isHidden"
    :is-open="isOpen"
    :title="$t('Configurator.selectIndication')"
    size="lg"
    ref="modal"
    v-on:clickclose="closeDialog"
    :alert="alertTitle"
    :alert-style="alertStyle"
    :alert-text="alertText"
    :alert-icon="alertIcon"
    alert-dismissable
    v-on:dismissalert="closeAlert"
    v-on:close="reset"
    :no-padding="true"
  >

    <template slot="footer">
      <button v-if="editing" type="button" class="float-left btn btn-danger" v-on:click="removeTooth"><i class="fa fa-times"></i> {{ $t('Action.remove') }}</button>
      <button type="button" class="btn btn-default" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
      <button type="button" :disabled="saveDisabled" class="btn btn-success" v-on:click="save"><i class="fa fa-check"></i> {{ $t('Action.finish') }}</button>
      <div class="clear"></div>
    </template>

    <card body-class="nopadding" v-on:change="handleChangeTab" :active-tab="activeTab">
          <cardtab v-for="(section, sectionIndex) in modelTree" :title="$root.getLabelText(section.label)"
                   :id="section.id" :hidden="!isSectionVisible(section)"
                   :badge="selection[section.id] ? '✔' : null" :badge-color="selection[section.id] ? 'success' : null">
          <div class="row" style="min-height: 350px;">
            <div class="col-md-4 col-sd-4 col-xs-4">
              <finderframe
                v-on:click="selectItem"
                :index="section.id"
                :children="section.children"
                :active-child="selection[section.id]"
                :targetTooth="Number(toothNumber)"
              ></finderframe>
            </div>
            <div class="col-md-8 col-sd-8 col-xs-8">
              <form v-if="selection[section.id]" class="form form-horizontal">
                <field
                  :group="section.id"
                  v-for="(field, name) in forms[section.id]"
                  label-class="col-md-12 col-sm-12 col-xs-12"
                  field-class="col-md-12 col-sm-12 col-xs-12"
                  :name="name"
                  :label="$root.getLabelText(field.label)"
                  :placeholder="$root.getLabelText(field.label)"
                  :tooltip="$root.getLabelText(field.tooltip)"
                  :type="fieldType(field)"
                  :required="field.required"
                  :check-value="field.itemnum"
                  :options="field.options"
                  :default-value="field.defaultValue"
                  :value="values[section.id][name]"
                  v-on:input="handleTabFormInput"
                ></field>
              </form>
            </div>
          </div>
        </cardtab>
    </card>
  </modal>
</template>

<script>
import Finder from '../Elements/Finder.vue';
import FinderFrame from '../Elements/FinderFrame.vue';
import ProductPickerMixin from '../Mixins/ProductPicker.js';
import FormsMixin from '../Mixins/Forms.js';
var __s__ = require('../Jaws3d/support-fns');

var view = require('../view.js'),
    viewData = {
      editing: null,
      isHidden: true,
      isOpen: false,
      activeTab: null,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      selection: {},
      selectionConfirmed: false,
      productSelected: false,
      requireAttachments: [],
      itemnums: [],
      properties: [],
      forms: {},
      values: {},
      formValues: {},
      maxunits: 0,
      allowMultiple: false,
      cart: {},
      saveDisabled: true,
      finderTree: {}
    },
    resetData = Object.assign({}, viewData);

var ColorHash = require('color-hash');
var colorHash = new ColorHash();

export default view(viewData, {
  mixins: [ ProductPickerMixin, FormsMixin ],
  components: {
    finder: Finder,
    finderframe: FinderFrame
  },
  props: {
    toothNumber: {},
    modelTree: {}
  },
  methods: {
    // ProductPickerMixin - revertSelection()
    // ProductPickerMixin - updateSelection(selection)
    // ProductPickerMixin - collectProperties(selection, property)
    // ProductPickerMixin - getItems(fileCount)
    getBranch() {
      // Retrieves the modelTree as main branch for ProductPickerMixin->collectProperties
      return this.modelTree;
    },
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          viewData[i] = resetData[i];
        }
      }

      this.init({}, {});
    },
    init(selection, values) {
      viewData.selection = {};
      viewData.values = {};
      viewData.forms = {};

      if (typeof values !== 'object') {
        values = {};
      }

      if (typeof selection !== 'object') {
        selection = {};
      }

      if (Array.isArray(this.modelTree) && this.modelTree.length > 0) {
        // Open the first tab
        const firstSection = this.getFirstVisibleSection();
        if (firstSection && firstSection.hasOwnProperty('id')) {
          this.activeTab = firstSection.id;
        }

        // Initialize the selection (including forms)
        this.modelTree.forEach(function(model) {
          if (typeof selection[model.id] === 'string') {
            this.selectItem(null, model.id, selection[model.id]);
            if (typeof values[model.id] === 'object') {
              viewData.values[model.id] = values[model.id];
            }
          } else {
            viewData.selection[model.id] = null;
            viewData.values[model.id] = {};
            viewData.forms[model.id] = {};
          }
        }.bind(this));
      }

      this.updateFormValues();
      this.$forceUpdate();
    },
    confirmSelection() {
      viewData.selectionConfirmed = true;
      // viewData.values = {};
    },
    removeTooth() {
      this.closeAlert();
      this.$emit('remove', this.editing);
      this.closeDialog();
    },
    load(tooth) {
      this.editing = tooth.toothNumber;
      this.init(tooth.selection, tooth.values);
    },
    save() {
      if (!this.checkForm()) {
        return false;
      }

      var tooth = {
        toothNumber: typeof this.toothNumber == 'string' ? parseInt(this.toothNumber) : this.toothNumber,
        itemnums: this.getItems(),
        isFlatrate: this.getIsFlatrate(),
        color: this.getColor(),
        material: this.getMaterial(),
        requireAttachments: this.getRequireAttachments(),
        values: this.getValues(),
        appliesTo: this.getAppliesTo(),
        useEntireRange: this.getUseEntireRange(),
        connect: this.getConnect(),
        selection: this.getSelection(),
        hasAbutment: this.getAbutment(),
        itemName: this.getItemName()
      };

      this.closeAlert();
      this.$emit('save', tooth);
      this.closeDialog();
    },
    selectItem(child, frameIndex, index) {
      this.forms[frameIndex] = {};
      this.values[frameIndex] = {};

      if (this.selection[frameIndex] === index) {
        this.selection[frameIndex] = null;
      } else {
        this.selection[frameIndex] = index;

        // Set the form properties
        if (Array.isArray(this.modelTree) && this.modelTree.length > 0) {
          var model = {};
          for (var i = 0 ; i < this.modelTree.length ; i++) {
            if (this.modelTree[i].id === frameIndex) {
              model = this.modelTree[i];
              break;
            }
          }

          if (typeof model.properties === 'object') {
            Object.keys(model.properties).forEach(function(prop) {
              this.forms[model.id][prop] = model.properties[prop];
              // Save flat form for price calculation
              this.form[model.id + '_' + prop] = model.properties[prop];
            }.bind(this));
          }

          if (typeof model.children === 'object') {
            if (typeof model.children[index] === 'object') {
              if (model.children[index].hasOwnProperty('properties')) {
                Object.keys(model.children[index].properties).forEach(function(prop) {
                  this.forms[model.id][prop] = model.children[index].properties[prop];
                  // Save flat form for price calculation
                  this.form[model.id + '_' + prop] = model.children[index].properties[prop];
                }.bind(this));
              }
            }
          }
        }
      }

      this.saveDisabled = !this.hasSelection();
      this.$forceUpdate();
    },
    hasSelection() {
      for (var i in this.selection) {
        if (this.selection.hasOwnProperty(i) && this.selection[i] !== null) {
          return true;
        }
      }

      return false;
    },
    getAppliesTo() {
      if (Array.isArray(this.modelTree)) {
        for (var i = 0 ; i < this.modelTree.length ; i++) {
          if (this.selection[this.modelTree[i].id] !== null
            && (typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]] === 'object')
            && (Array.isArray(this.modelTree[i].children[this.selection[this.modelTree[i].id]].appliesTo))
          ) {
            return this.modelTree[i].children[this.selection[this.modelTree[i].id]].appliesTo;
          }
        }
      }
      return '';
    },
    getIsFlatrate() {
      if (Array.isArray(this.modelTree)) {
        for (let i = 0 ; i < this.modelTree.length ; i++) {
          if (this.selection[this.modelTree[i].id] !== null
            && (typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]] === 'object')
            && (typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]].flatrate === 'boolean')
          ) {
            return this.modelTree[i].children[this.selection[this.modelTree[i].id]].flatrate;
          }
        }
      }
      return false;
    },
    getUseEntireRange() {
      if (Array.isArray(this.modelTree)) {
        for (let i = 0 ; i < this.modelTree.length ; i++) {
          if (this.selection[this.modelTree[i].id] !== null
            && (typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]] === 'object')
            && (typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]].useEntireRange === 'boolean')
          ) {
            return this.modelTree[i].children[this.selection[this.modelTree[i].id]].useEntireRange;
          }
        }
      }
      return false;
    },
    getConnect() {
      if (Array.isArray(this.modelTree)) {
        for (let i = 0 ; i < this.modelTree.length ; i++) {
          if (this.selection[this.modelTree[i].id] !== null
            && typeof this.modelTree[i] === 'object') {
            return this.modelTree[i].connect;
          }
        }
      }
      return false;
    },
    getSelection() {
      // Get cleared selection
      var selection = {};
      Object.keys(this.selection).forEach(function(group) {
        if (this.selection[group] !== null) {
          selection[group] = this.selection[group];
        }
      }.bind(this));

      return selection;
    },
    getValues() {
      // Get cleared selection

      var values = {};
      Object.keys(this.values).forEach(function(group) {
        let keys = Object.keys(this.values[group]);

        if (keys.length > 0) {
          values[group] = {};
        }

        keys.forEach(function(key) {
          values[group][key] = this.values[group][key];
        }.bind(this));
      }.bind(this));

      return values;
    },
    getItems() {
      var itemnum, items  = {};

      var incItemnum = function(itemnum) {
        if (typeof items[itemnum] === 'undefined') {
          items[itemnum] = 1;
        } else {
          items[itemnum]++
        }
      }.bind(this);

      var addItem = function(obj) {
        if (typeof this.values.itemnum === 'string') {
          obj.itemnum = this.values.itemnum;
          delete this.values.itemnum;
        }
        if (typeof obj.itemnum === 'string') {
          incItemnum(obj.itemnum);
        } else if (typeof obj.itemnum === 'object' && obj.itemnum instanceof Array) {
          // @HACK to support multiple item numbers
          obj.itemnum.forEach((itemnum) => {
            incItemnum(itemnum);
          });
        }
      }.bind(this);

      if (Array.isArray(this.modelTree) && this.modelTree.length > 0) {
        this.modelTree.forEach(function(model) {
          if (this.selection[model.id] !== null) {
            if (typeof model.children === 'object'
              && typeof model.children[this.selection[model.id]] === 'object') {
              addItem(model.children[this.selection[model.id]]);
            }
          }
        }.bind(this));

        Object.keys(this.values).forEach(group => {
          Object.keys(this.values[group]).forEach(property => {
            if (typeof this.modelTree[group] !== 'undefined'
                && typeof this.modelTree[group].children === 'object') {
              Object.keys(this.modelTree[group].children).forEach(childId => {
                if (typeof this.modelTree[group].children[childId].properties === 'object'
                  && typeof this.modelTree[group].children[childId].properties[property] === 'object') {
                    addItem(this.modelTree[group].children[childId].properties[property]);
                }
              });
            }
          });
        });
      }

      return items;
    },

    getItemName() {
      // Item name depends on the first selected level
      if (Array.isArray(this.modelTree)) {
        for (var i = 0 ; i < this.modelTree.length ; i++) {
          if (this.selection[this.modelTree[i].id] !== null
            && (typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]] === 'object')
            && (
              typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]].label === 'string'
              || typeof this.modelTree[i].children[this.selection[this.modelTree[i].id]].label === 'object'
            )
            ) {
            return this.$root.getLabelText(this.modelTree[i].children[this.selection[this.modelTree[i].id]].label);
          }
        }
      }

      return '';
    },
    getMaterial() {
      var material = null;
      Object.keys(this.values).forEach(function(group) {
        Object.keys(this.values[group]).forEach(function(key) {
          if (key === 'material') {
            material = this.values[group][key];
          }
        }.bind(this));
      }.bind(this));

      return material;
    },
    getAbutment() {
      return typeof this.selection.abutment === 'string';
    },
    getColor() {
      var color = null;

      if (Array.isArray(this.modelTree) && this.modelTree.length > 0) {
        this.modelTree.forEach(function(model) {
          if (this.selection[model.id] !== null) {
            if (color === null && typeof model.color !== 'undefined') {
              color = model.color;
            }

            if (typeof model.children[this.selection[model.id]] === 'object'
                && typeof model.children[this.selection[model.id]].color !== 'undefined') {
              color = model.children[this.selection[model.id]].color;
            }
          }
        }.bind(this));
      }

      if (color === null) {
        var selection = '';
        Object.keys(this.selection).forEach(function(group) {
          if (this.selection[group] !== null) {
            selection += this.selection[group];
          }
        }.bind(this));

        color = colorHash.hex(selection);
      }

      return color;
    },
    getRequireAttachments() {
      var requireAttachments = [];

      if (Array.isArray(this.modelTree) && this.modelTree.length > 0) {
        this.modelTree.forEach(function(model) {
          if (this.selection[model.id] !== null) {
            if ((typeof model.requireAttachments === 'object')
                && model.requireAttachments instanceof Array) {

              model.requireAttachments.forEach(function(req) {
                requireAttachments.push(req);
              });
            }

            if ((typeof model.children[this.selection[model.id]] === 'object')
                && (typeof model.children[this.selection[model.id]].requireAttachments === 'object')
                && model.children[this.selection[model.id]].requireAttachments instanceof Array) {

              model.children[this.selection[model.id]].requireAttachments.forEach(function(req) {
                requireAttachments.push(req);
              });
            }
          }
        }.bind(this));
      }

      return requireAttachments;
    },
    isSectionVisible(section) {
      if (this.toothNumber) {
        const childNames = Object.keys(section.children);
        for (let k = 0; k < childNames.length; k++) {
          const child = section.children[childNames[k]];
          if (Array.isArray(child.appliesTo) && child.appliesTo.length === 2) {
            if (__s__.isToothNumberInRange(this.toothNumber, child.appliesTo[0], child.appliesTo[1])) {
              return true;
            }
          } else {
            return true;
          }
        }
      }
      return false;
    },
    getFirstVisibleSection() {
      if (Array.isArray(this.modelTree) && this.modelTree.length > 0) {
        for (let k =0; k < this.modelTree.length; k++) {
          if (this.isSectionVisible(this.modelTree[k])) {
            return this.modelTree[k];
          }
        }
      }
      return null;
    },
    handleTabFormInput(value, field) {
      this.values[field.group][field.name] = value;
      if (field.options && field.options[value] && field.options[value].itemnum) {
        this.values['itemnum'] = field.options[value].itemnum;
      } else {
        delete this.values['itemnum'];
      }
      this.updateFormValues();
      this.$forceUpdate();
    },
    checkForm() {
      for (var group in this.forms) {
        if (typeof this.forms[group] === 'object') {
          for (var key in this.forms[group]) {
            if (
              this.forms[group].hasOwnProperty(key)
              && (typeof this.forms[group][key].required != 'undefined')
              && this.forms[group][key].required
              && this.meetsRequirements(this.forms[group][key])
              && (
                (typeof this.values[group][key] == 'undefined')
                || this.values[group][key] == null
                || this.values[group][key] == ''
              )
            ) {
              alert(this.$t('Common.errorFieldMissing', {field: this.$t(this.forms[group][key].label)}));
              return false;
            }
          }
        }
      }

      return true;
    },
    updateFormValues() {
      // Computed properties won't work with multi-dimensional objects.
      this.formValues = {};
      Object.keys(this.values).forEach(function(group) {
        Object.keys(this.values[group]).forEach(function(key) {
          this.formValues[group + '_' + key] = this.values[group][key];
        }.bind(this));
      }.bind(this));
    },
    handleChangeTab(tabId) {
      this.activeTab = tabId;
    },
    closeDialog() {
      this.$refs.modal.close(this);
    },
    openDialog() {
      this.$refs.modal.open(this);
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    }
  }
});
</script>
